import { Product } from '../types';

// ============================================
// SWITCHES
// ============================================
export const switchProducts: Product[] = [
  {
    id: "switch-ss30007",
    name: "Push Pull Small (Deluxe) - SS30007",
    slug: "push-pull-small-deluxe-ss30007",
    category: "Switches",
    description: "Push Pull Small Deluxe switch with black cylindrical knob featuring SAROOP logo. Silver ring and threaded shaft with hexagonal black plastic base.",
    partNumber: "SS30007",
    images: ["/products/electrical-components/switches/SS30007.jpg"],
    featured: true,
    specifications: {
      "Type": "Push Pull",
      "Size": "Small",
      "Variant": "Deluxe",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "push-pull", "small", "deluxe", "automotive"],
    applications: ["Automotive", "Lighting Control"],
  },
  {
    id: "switch-ss30010",
    name: "Push Pull Long (Regular) - SS30010",
    slug: "push-pull-long-regular-ss30010",
    category: "Switches",
    description: "Push Pull Long Regular switch with tall, slender black cylindrical knob featuring SAROOP logo. Silver ring and threaded shaft with hexagonal black plastic base.",
    partNumber: "SS30010",
    images: ["/products/electrical-components/switches/SS30010.jpg"],
    specifications: {
      "Type": "Push Pull",
      "Size": "Long",
      "Variant": "Regular",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "push-pull", "long", "regular", "automotive"],
    applications: ["Automotive", "Lighting Control"],
  },
  {
    id: "switch-ss30011",
    name: "Push Pull Long (Deluxe) - SS30011",
    slug: "push-pull-long-deluxe-ss30011",
    category: "Switches",
    description: "Push Pull Long Deluxe switch with elongated black cylindrical knob featuring SAROOP logo. Silver ring and threaded shaft with hexagonal black plastic base.",
    partNumber: "SS30011",
    images: ["/products/electrical-components/switches/SS30011.jpg"],
    specifications: {
      "Type": "Push Pull",
      "Size": "Long",
      "Variant": "Deluxe",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "push-pull", "long", "deluxe", "automotive"],
    applications: ["Automotive", "Lighting Control"],
  },
  {
    id: "switch-ss30014",
    name: "Push Pull Long Big (Nob) - SS30014",
    slug: "push-pull-long-big-nob-ss30014",
    category: "Switches",
    description: "Push Pull Long Big Nob switch with larger, rounded bulbous black knob featuring SAROOP logo. Silver ring and threaded shaft with hexagonal black plastic base.",
    partNumber: "SS30014",
    images: ["/products/electrical-components/switches/SS30014.jpg"],
    specifications: {
      "Type": "Push Pull",
      "Size": "Long Big",
      "Variant": "Nob",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "push-pull", "long", "big", "nob", "automotive"],
    applications: ["Automotive", "Lighting Control"],
  },
  {
    id: "switch-ss30016",
    name: "Push Pull Long Deluxe (Small Nob) - SS30016",
    slug: "push-pull-long-deluxe-small-nob-ss30016",
    category: "Switches",
    description: "Push Pull Long Deluxe Small Nob switch with very tall and slender black cylindrical knob. Silver ring and threaded shaft with hexagonal black plastic base.",
    partNumber: "SS30016",
    images: ["/products/electrical-components/switches/SS30016.jpg"],
    specifications: {
      "Type": "Push Pull",
      "Size": "Long Deluxe",
      "Variant": "Small Nob",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "push-pull", "long", "deluxe", "small-nob", "automotive"],
    applications: ["Automotive", "Lighting Control"],
  },
  {
    id: "switch-ss30018",
    name: "Push Pull Extra Long - SS30018",
    slug: "push-pull-extra-long-ss30018",
    category: "Switches",
    description: "Push Pull Extra Long switch with mushroom-shaped black knob on notably long silver threaded shaft. Hexagonal black plastic base.",
    partNumber: "SS30018",
    images: ["/products/electrical-components/switches/SS30018.jpg"],
    specifications: {
      "Type": "Push Pull",
      "Size": "Extra Long",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "push-pull", "extra-long", "automotive"],
    applications: ["Automotive", "Lighting Control"],
  },
  {
    id: "switch-ss30031",
    name: "Toggle Switch - SS30031",
    slug: "toggle-switch-ss30031",
    category: "Switches",
    description: "Toggle switch with black lever-style design. Black plastic body with silver threaded mounting base and brass screw terminals.",
    partNumber: "SS30031",
    images: ["/products/electrical-components/switches/SS30031.jpg"],
    specifications: {
      "Type": "Toggle",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "toggle", "automotive"],
    applications: ["Automotive", "General Switching"],
  },
  {
    id: "switch-ss30054",
    name: "Horn Button - SS30054",
    slug: "horn-button-ss30054",
    category: "Switches",
    description: "Horn button with clear/translucent top, ribbed brass body, and black rectangular plastic base with brass screw terminals.",
    partNumber: "SS30054",
    images: ["/products/electrical-components/switches/SS30054.jpg"],
    specifications: {
      "Type": "Push Button",
      "Application": "Horn",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "horn", "button", "automotive"],
    applications: ["Automotive", "Horn Activation"],
  },
  {
    id: "switch-ss30059",
    name: "Starter/Horn Button Brass Body - SS30059",
    slug: "starter-horn-button-brass-ss30059",
    category: "Switches",
    description: "Heavy-duty starter and horn button with prominent red plastic top, brass body, and black plastic base with three brass screw terminals.",
    partNumber: "SS30059",
    images: ["/products/electrical-components/switches/SS30059.jpg"],
    specifications: {
      "Type": "Push Button",
      "Application": "Starter/Horn",
      "Material": "Brass Body",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "starter", "horn", "button", "brass", "automotive"],
    applications: ["Automotive", "Starter", "Horn Activation", "Heavy Duty"],
  },
  {
    id: "switch-ss31001",
    name: "Head Light Switch - SS31001",
    slug: "head-light-switch-ss31001",
    category: "Switches",
    description: "Headlight switch with orange cylindrical knob attached to metal shaft. Black rectangular plastic body with multiple brass screw terminals.",
    partNumber: "SS31001",
    images: ["/products/electrical-components/switches/SS31001.jpg"],
    specifications: {
      "Type": "Headlight Switch",
      "Packing": "10 Pcs. Packing",
    },
    tags: ["switch", "headlight", "automotive"],
    applications: ["Automotive", "Headlight Control"],
  },
];

// ============================================
// FLASHERS
// ============================================
export const flasherProducts: Product[] = [
  {
    id: "smf31202",
    name: "Musical Flasher Relay 12V",
    slug: "musical-flasher-relay-12v-smf31202",
    category: "Flasher",
    subcategory: "Musical Flasher",
    description:
      "Musical flasher relay with melody indication for turn signals.",
    partNumber: "SMF31202",
    image: "/products/electrical-components/musical-flasher/SMF31202.jpg",
    featured: true,
    specifications: {
      Type: "Musical",
      Voltage: "12V",
      Feature: "Melody indication",
    },
    tags: ["flasher", "musical", "12v"],
    applications: ["2-Wheeler", "3-Wheeler", "Automotive"],
  },

  {
    id: "smf31203",
    name: "Musical Flasher Relay 12V",
    slug: "musical-flasher-relay-12v-smf31203",
    category: "Flasher",
    subcategory: "Musical Flasher",
    description:
      "Musical flasher relay with melody indication for turn signals.",
    partNumber: "SMF31203",
    image: "/products/electrical-components/musical-flasher/SMF31203.jpg",
    specifications: {
      Type: "Musical",
      Voltage: "12V",
      Feature: "Melody indication",
    },
    tags: ["flasher", "musical", "12v"],
    applications: ["Automotive"],
  },

  {
    id: "smf32402",
    name: "Musical Flasher Relay 24V",
    slug: "musical-flasher-relay-24v-smf32402",
    category: "Flasher",
    subcategory: "Musical Flasher",
    description:
      "Musical flasher relay with melody indication for turn signals.",
    partNumber: "SMF32402",
    image: "/products/electrical-components/musical-flasher/SMF32402.jpg",
    specifications: {
      Type: "Musical",
      Voltage: "24V",
      Feature: "Melody indication",
    },
    tags: ["flasher", "musical", "24v"],
    applications: ["Commercial Vehicles"],
  },

  {
    id: "smf32403",
    name: "Musical Flasher Relay 24V",
    slug: "musical-flasher-relay-24v-smf32403",
    category: "Flasher",
    subcategory: "Musical Flasher",
    description:
      "Musical flasher relay with melody indication for turn signals.",
    partNumber: "SMF32403",
    image: "/products/electrical-components/musical-flasher/SMF32403.jpg",
    specifications: {
      Type: "Musical",
      Voltage: "24V",
      Feature: "Melody indication",
    },
    tags: ["flasher", "musical", "24v"],
    applications: ["Commercial Vehicles"],
  },

  {
    id: "sef31211",
    name: "Electronic Flasher Relay 12V",
    slug: "electronic-flasher-relay-12v-sef31211",
    category: "Flasher",
    subcategory: "Electronic Flasher",
    description:
      "Electronic turn signal flasher relay compatible with LED and incandescent bulbs.",
    partNumber: "SEF31211",
    image: "/products/electrical-components/electronic-flasher/SEF31211.jpg",
    specifications: {
      Type: "Electronic",
      Voltage: "12V",
      Compatibility: "LED & Incandescent",
    },
    tags: ["flasher", "electronic", "12v"],
    applications: ["Automotive"],
  },

  {
    id: "sef32411",
    name: "Electronic Flasher Relay 24V",
    slug: "electronic-flasher-relay-24v-sef32411",
    category: "Flasher",
    subcategory: "Electronic Flasher",
    description:
      "Electronic turn signal flasher relay for commercial vehicles.",
    partNumber: "SEF32411",
    image: "/products/electrical-components/electronic-flasher/SEF32411.jpg",
    specifications: {
      Type: "Electronic",
      Voltage: "24V",
      Compatibility: "LED & Incandescent",
    },
    tags: ["flasher", "electronic", "24v"],
    applications: ["Commercial Vehicles"],
  },
];

// ============================================
// TUNERS
// ============================================
export const tunerProducts: Product[] = [
  {
    id: "tuner-1",
    name: "4 Way Tuner",
    slug: "4-way-tuner",
    category: "Tuner",
    description: "4-way electrical distribution tuner for vehicle wiring.",
    specifications: {
      "Ways": "4",
      "Applications": "Electrical distribution",
    },
    tags: ["tuner", "4-way", "distribution"],
    applications: ["Automotive", "Electrical Distribution"],
    partNumber: "ST41201",
    image: "/products/electrical-components/tuner/ST41201.jpg",
  },
  {
    id: "tuner-2",
    name: "7 Way Tuner",
    slug: "7-way-tuner",
    category: "Tuner",
    description: "7-way electrical distribution tuner.",
    specifications: {
      "Ways": "7",
      "Applications": "Electrical distribution",
    },
    tags: ["tuner", "7-way"],
    applications: ["Automotive", "Electrical Distribution"],
    partNumber: "ST71201",
    image: "/products/electrical-components/tuner/ST71201.jpg",
  },
  {
    id: "tuner-3",
    name: "8 Way Tuner",
    slug: "8-way-tuner",
    category: "Tuner",
    description: "8-way electrical distribution tuner.",
    specifications: {
      "Ways": "8",
      "Applications": "Electrical distribution",
    },
    tags: ["tuner", "8-way"],
    applications: ["Automotive", "Electrical Distribution"],
    partNumber: "ST81201",
    image: "/products/electrical-components/tuner/ST81201.jpg",
  },
];

// ============================================
// RELAYS
// ============================================
export const relayProducts: Product[] = [
  {
    id: "relay-2",
    name: "Starting Relay 12V",
    slug: "starting-relay-12v",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Starter motor relay for vehicle ignition systems. Suitable for 2 & 4 Wheeler.",
    partNumber: "S2WR21201",
    image: "/products/electrical-components/2wheeler-relay/S2WR21201.jpg",
    specifications: {
      "Type": "Starter Relay",
      "Voltage": "12V",
      "Applications": "Ignition system",
    },
    tags: ["relay", "starting", "12v"],
    applications: ["Automotive", "Starting System"],
  },
  {
    id: "relay-5",
    name: "Head Light Relay 12V",
    slug: "headlight-relay-12v",
    category: "Relay",
    subcategory: "Headlight Relay",
    description: "High-power relay for headlight circuits. Improves light output and protects switch. 6 Pin with wire.",
    partNumber: "SR61201",
    image: "/products/electrical-components/headlight-relay/SR61201.jpg",
    featured: true,
    specifications: {
      "Type": "Headlight Relay",
      "Voltage": "12V",
      "Rating": "30A/40A",
      "Pins": "6",
      "Applications": "Headlight upgrade",
    },
    tags: ["relay", "headlight", "12v"],
    applications: ["Automotive", "Lighting"],
  },
  {
    id: "relay-6",
    name: "Head Light Relay 24V",
    slug: "headlight-relay-24v",
    category: "Relay",
    subcategory: "Headlight Relay",
    description: "High-power relay for headlight circuits in commercial vehicles. 6 Pin with wire.",
    partNumber: "SR62401",
    image: "/products/electrical-components/headlight-relay/SR62401.jpg",
    specifications: {
      "Type": "Headlight Relay",
      "Voltage": "24V",
      "Rating": "30A/40A",
      "Pins": "6",
      "Applications": "Headlight upgrade",
    },
    tags: ["relay", "headlight", "24v"],
    applications: ["Commercial Vehicles", "Lighting"],
  },
  {
    id: "relay-7",
    name: "Horn Relay 3 Pin 12V With Wire",
    slug: "horn-relay-3pin-12v",
    category: "Relay",
    subcategory: "Horn Relay",
    description: "3 Pin Horn Relay 12V with wire for horn circuits.",
    partNumber: "SR31201",
    image: "/products/electrical-components/horn-relay/SR31201.jpg",
    specifications: {
      "Type": "Horn Relay",
      "Voltage": "12V",
      "Pins": "3",
      "Applications": "Horn circuits",
    },
    tags: ["relay", "horn", "12v"],
    applications: ["Automotive"],
  },
  {
    id: "relay-8",
    name: "5 Pin Micro Relay 12V",
    slug: "5-pin-micro-relay-12v",
    category: "Relay",
    subcategory: "Micro Relay",
    description: "Compact 5 pin micro relay for 12V automotive applications.",
    partNumber: "SR51201",
    image: "/products/electrical-components/relay/SR51201.jpg",
    specifications: {
      "Type": "Micro Relay",
      "Voltage": "12V",
      "Pins": "5",
    },
    tags: ["relay", "micro", "12v"],
    applications: ["Automotive"],
  },
  {
    id: "relay-9",
    name: "5 Pin Micro Relay 24V",
    slug: "5-pin-micro-relay-24v",
    category: "Relay",
    subcategory: "Micro Relay",
    description: "Compact 5 pin micro relay for 24V commercial vehicle applications.",
    partNumber: "SR52401",
    image: "/products/electrical-components/relay/SR52401.jpg",
    specifications: {
      "Type": "Micro Relay",
      "Voltage": "24V",
      "Pins": "5",
    },
    tags: ["relay", "micro", "24v"],
    applications: ["Commercial Vehicles"],
  },
  {
    id: "relay-10",
    name: "Mini Relay 4 Pin 12V",
    slug: "mini-relay-4pin-12v",
    category: "Relay",
    subcategory: "Mini Relay",
    description: "Suitable for 4 Wheeler Mini Relay 4 Pin 12V. Compact mini relay for 12V systems.",
    partNumber: "SR41229",
    image: "/products/electrical-components/relay/SR41229.jpg",
    specifications: {
      "Type": "Mini Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "mini", "12v", "4-wheeler"],
    applications: ["Automotive"],
  },
  {
    id: "relay-11",
    name: "Transparent Relay 4 Pin 12V",
    slug: "transparent-relay-4pin-12v",
    category: "Relay",
    subcategory: "Transparent Relay",
    description: "Suitable for 4 Wheeler Transparent Relay 4 Pin 12V. Transparent housing for easy fault diagnosis.",
    partNumber: "SR41221",
    image: "/products/electrical-components/relay/SR41221.jpg",
    specifications: {
      "Type": "Transparent",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "transparent", "12v", "4-wheeler"],
    applications: ["Automotive"],
  },
  // Horn Relay 24V (Horn & Head Light Relay)
  {
    id: "relay-12",
    name: "Horn Relay 3 Pin 24V With Wire",
    slug: "horn-relay-3pin-24v-with-wire",
    category: "Relay",
    subcategory: "Horn Relay",
    description: "3 Pin Horn Relay 24V with wire for horn circuits.",
    partNumber: "SR32401",
    image: "/products/electrical-components/horn-relay/SR32401.jpg",
    specifications: {
      "Type": "Horn Relay",
      "Voltage": "24V",
      "Pins": "3",
      "Rating": "10A",
      "Applications": "Horn circuits",
    },
    tags: ["relay", "horn", "24v"],
    applications: ["Automotive", "Commercial Vehicles"],
  },
  // 4 Wheeler Horn / Micro / Starting / Transparent / Standard (from Relay catalog)
  {
    id: "relay-13",
    name: "4 Wheeler Horn Relay 3 Pin 12V",
    slug: "4-wheeler-horn-relay-3pin-12v",
    category: "Relay",
    subcategory: "Horn Relay",
    description: "Suitable for 4 Wheeler Horn Relay 3 Pin 12V.",
    partNumber: "SR31211",
    image: "/products/electrical-components/relay/SR31211.jpg",
    specifications: {
      "Type": "Horn Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "3",
    },
    tags: ["relay", "horn", "12v", "4-wheeler"],
    applications: ["Automotive"],
  },
  {
    id: "relay-14",
    name: "4 Wheeler Micro Relay 4 Pin 12V",
    slug: "4-wheeler-micro-relay-4pin-12v",
    category: "Relay",
    subcategory: "Micro Relay",
    description: "Suitable for 4 Wheeler Micro Relay 4 Pin 12V.",
    partNumber: "SR41201",
    image: "/products/electrical-components/relay/SR41201.jpg",
    specifications: {
      "Type": "Micro Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "micro", "12v", "4-wheeler"],
    applications: ["Automotive"],
  },
  {
    id: "relay-15",
    name: "4 Wheeler Micro Relay 4 Pin 24V",
    slug: "4-wheeler-micro-relay-4pin-24v",
    category: "Relay",
    subcategory: "Micro Relay",
    description: "Suitable for 4 Wheeler Micro Relay 4 Pin 24V.",
    partNumber: "SR42401",
    image: "/products/electrical-components/relay/SR42401.jpg",
    specifications: {
      "Type": "Micro Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "24V",
      "Pins": "4",
    },
    tags: ["relay", "micro", "24v", "4-wheeler"],
    applications: ["Commercial Vehicles"],
  },
  {
    id: "relay-16",
    name: "4 Wheeler Starting Relay 4 Pin 12V",
    slug: "4-wheeler-starting-relay-4pin-12v",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Suitable for 4 Wheeler Starting Relay 4 Pin 12V.",
    partNumber: "SR41211",
    image: "/products/electrical-components/relay/SR41211.jpg",
    specifications: {
      "Type": "Starting Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "starting", "12v", "4-wheeler"],
    applications: ["Automotive", "Starting System"],
  },
  {
    id: "relay-17",
    name: "4 Wheeler Starting Relay 4 Pin 24V",
    slug: "4-wheeler-starting-relay-4pin-24v",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Suitable for 4 Wheeler Starting Relay 4 Pin 24V.",
    partNumber: "SR42411",
    image: "/products/electrical-components/relay/SR42411.jpg",
    specifications: {
      "Type": "Starting Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "24V",
      "Pins": "4",
    },
    tags: ["relay", "starting", "24v", "4-wheeler"],
    applications: ["Commercial Vehicles", "Starting System"],
  },
  {
    id: "relay-18",
    name: "4 Wheeler Transparent Relay 4 Pin 12V",
    slug: "4-wheeler-transparent-relay-4pin-12v-sr41223",
    category: "Relay",
    subcategory: "Transparent Relay",
    description: "Suitable for 4 Wheeler Transparent Relay 4 Pin 12V.",
    partNumber: "SR41223",
    image: "/products/electrical-components/relay/SR41223.jpg",
    specifications: {
      "Type": "Transparent",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "transparent", "12v", "4-wheeler"],
    applications: ["Automotive"],
  },
  {
    id: "relay-19",
    name: "4 Wheeler Relay 4 Pin 12V",
    slug: "4-wheeler-relay-4pin-12v-sr41227",
    category: "Relay",
    subcategory: "4 Wheeler",
    description: "Suitable for 4 Wheeler Relay 4 Pin 12V.",
    partNumber: "SR41227",
    image: "/products/electrical-components/relay/SR41227.jpg",
    specifications: {
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "4-wheeler", "12v"],
    applications: ["Automotive"],
  },
  // Starting Relay catalog
  {
    id: "relay-20",
    name: "4 Wheeler Mini Relay 4 Pin 12V",
    slug: "4-wheeler-mini-relay-4pin-12v-sr41233",
    category: "Relay",
    subcategory: "Mini Relay",
    description: "Suitable for 4 Wheeler Mini Relay 4 Pin 12V.",
    partNumber: "SR41233",
    image: "/products/electrical-components/relay/SR41233.jpg",
    specifications: {
      "Type": "Mini Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "mini", "12v", "4-wheeler"],
    applications: ["Automotive"],
  },
  {
    id: "relay-21",
    name: "4 Wheeler Big Relay 4 Pin 12V",
    slug: "4-wheeler-big-relay-4pin-12v",
    category: "Relay",
    subcategory: "4 Wheeler",
    description: "Suitable for 4 Wheeler Big Relay 4 Pin 12V.",
    partNumber: "SR41235",
    image: "/products/electrical-components/relay/SR41235.jpg",
    specifications: {
      "Type": "Big Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "4-wheeler", "12v", "big"],
    applications: ["Automotive"],
  },
  {
    id: "relay-22",
    name: "4 Wheeler Starting Relay 4 Pin 12V",
    slug: "4-wheeler-starting-relay-4pin-12v-sr41238",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Suitable for 4 Wheeler Starting Relay 4 Pin 12V.",
    partNumber: "SR41238",
    image: "/products/electrical-components/relay/SR41238.jpg",
    specifications: {
      "Type": "Starting Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "starting", "12v", "4-wheeler"],
    applications: ["Automotive", "Starting System"],
  },
  {
    id: "relay-23",
    name: "2 Wheeler Starting Relay 4 Pin 12V",
    slug: "2-wheeler-starting-relay-4pin-12v",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Suitable for 2 Wheeler Starting Relay 4 Pin 12V.",
    partNumber: "SR41242",
    image: "/products/electrical-components/relay/SR41242.jpg",
    specifications: {
      "Type": "Starting Relay",
      "Compatible": "2 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "starting", "12v", "2-wheeler"],
    applications: ["Motorcycles", "Scooters", "Starting System"],
  },
  {
    id: "relay-24",
    name: "2 Wheeler Starting Relay 4 Pin 24V",
    slug: "2-wheeler-starting-relay-4pin-24v",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Suitable for 2 Wheeler Starting Relay 4 Pin 24V.",
    partNumber: "SR42442",
    image: "/products/electrical-components/relay/SR42442.jpg",
    specifications: {
      "Type": "Starting Relay",
      "Compatible": "2 Wheelers",
      "Voltage": "24V",
      "Pins": "4",
    },
    tags: ["relay", "starting", "24v", "2-wheeler"],
    applications: ["Motorcycles", "Scooters", "Starting System"],
  },
  {
    id: "relay-25",
    name: "4 Wheeler 5 Pin Starting Relay 12V Small",
    slug: "4-wheeler-5pin-starting-relay-12v-small",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Suitable for 4 Wheeler 5 Pin Starting Relay 12V Small.",
    partNumber: "SR51210",
    image: "/products/electrical-components/relay/SR51210.jpg",
    specifications: {
      "Type": "Starting Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "5",
      "Size": "Small",
    },
    tags: ["relay", "starting", "12v", "4-wheeler", "5-pin", "small"],
    applications: ["Automotive", "Starting System"],
  },
  {
    id: "relay-26",
    name: "4 Wheeler 5 Pin Starting Relay 12V",
    slug: "4-wheeler-5pin-starting-relay-12v",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Suitable for 4 Wheeler 5 Pin Starting Relay 12V.",
    partNumber: "SR51211",
    image: "/products/electrical-components/relay/SR51211.jpg",
    specifications: {
      "Type": "Starting Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "5",
    },
    tags: ["relay", "starting", "12v", "4-wheeler", "5-pin"],
    applications: ["Automotive", "Starting System"],
  },
  {
    id: "relay-27",
    name: "4 Wheeler 5 Pin Starting Relay 12V Big",
    slug: "4-wheeler-5pin-starting-relay-12v-big",
    category: "Relay",
    subcategory: "Starting Relay",
    description: "Suitable for 4 Wheeler 5 Pin Starting Relay 12V Big.",
    partNumber: "SR51212",
    image: "/products/electrical-components/relay/SR51212.jpg",
    specifications: {
      "Type": "Starting Relay",
      "Compatible": "4 Wheelers",
      "Voltage": "12V",
      "Pins": "5",
      "Size": "Big",
    },
    tags: ["relay", "starting", "12v", "4-wheeler", "5-pin", "big"],
    applications: ["Automotive", "Starting System"],
  },
  // 2 Wheeler Relay catalog
  {
    id: "relay-28",
    name: "2 Wheeler Starting Relay 12V (With Patti)",
    slug: "2-wheeler-starting-relay-12v-with-patti",
    category: "Relay",
    subcategory: "2 Wheeler",
    description: "Suitable for 2 Wheeler Starting Relay 12V with Patti (mounting bracket).",
    partNumber: "S2WR21202",
    image: "/products/electrical-components/2wheeler-relay/S2WR21202.jpg",
    specifications: {
      "Type": "Starter Relay",
      "Compatible": "2 Wheelers",
      "Voltage": "12V",
      "With Patti": "Yes",
    },
    tags: ["relay", "starting", "12v", "2-wheeler", "patti"],
    applications: ["Motorcycles", "Scooters", "Starting System"],
  },
  {
    id: "relay-29",
    name: "Denso Mini Relay 4 Pin 12V",
    slug: "denso-mini-relay-4pin-12v",
    category: "Relay",
    subcategory: "2 Wheeler",
    description: "Suitable for Denso Mini Relay 4 Pin 12V. Compatible with 2 Wheeler applications.",
    partNumber: "S2WR41203",
    image: "/products/electrical-components/2wheeler-relay/S2WR41203.jpg",
    specifications: {
      "Type": "Mini Relay (Denso)",
      "Compatible": "2 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "mini", "12v", "2-wheeler", "denso"],
    applications: ["Motorcycles", "Scooters"],
  },
  {
    id: "relay-30",
    name: "2 & 4 Wheeler Relay 4 Pin 12V (With Fuse)",
    slug: "2-4-wheeler-relay-4pin-12v-with-fuse",
    category: "Relay",
    subcategory: "2 Wheeler",
    description: "Suitable for 2 & 4 Wheeler Relay 4 Pin 12V with fuse.",
    partNumber: "S2WR41211",
    image: "/products/electrical-components/2wheeler-relay/S2WR41211.jpg",
    specifications: {
      "Compatible": "2 & 4 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
      "With Fuse": "Yes",
    },
    tags: ["relay", "12v", "2-wheeler", "4-wheeler", "fuse"],
    applications: ["Motorcycles", "Scooters", "Cars", "SUVs"],
  },
  {
    id: "relay-31",
    name: "2 Wheeler Relay (Honda Activa) 4 Pin 12V",
    slug: "2-wheeler-relay-honda-activa-4pin-12v",
    category: "Relay",
    subcategory: "2 Wheeler",
    description: "Suitable for 2 Wheeler Relay (Honda Activa) 4 Pin 12V.",
    partNumber: "S2WR41218",
    image: "/products/electrical-components/2wheeler-relay/S2WR41218.jpg",
    specifications: {
      "Compatible": "Honda Activa / 2 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "12v", "2-wheeler", "honda-activa"],
    applications: ["Scooters", "Honda Activa"],
  },
  {
    id: "relay-32",
    name: "2 Wheeler Relay 4 Pin 12V",
    slug: "2-wheeler-relay-4pin-12v",
    category: "Relay",
    subcategory: "2 Wheeler",
    description: "Suitable for 2 Wheeler Relay 4 Pin 12V.",
    partNumber: "S2WR41220",
    image: "/products/electrical-components/2wheeler-relay/S2WR41220.jpg",
    specifications: {
      "Compatible": "2 Wheelers",
      "Voltage": "12V",
      "Pins": "4",
    },
    tags: ["relay", "12v", "2-wheeler"],
    applications: ["Motorcycles", "Scooters"],
  },
];
